// src/lib/authFetch.js
// Wrapper around `fetch` that attaches the current Supabase session's
// access token as `Authorization: Bearer <jwt>`.
//
// Every call to a `/api/*` endpoint that touches user-owned data should go
// through this helper. The server endpoints derive the user id from the
// JWT — anything passed as `userId` in the body/query is ignored.
//
// Usage:
//   import { authFetch } from '../lib/authFetch';
//   const res  = await authFetch('/api/ab?resource=pages&pageId=' + id);
//   const data = await res.json();
//
//   // POST works the same as fetch:
//   const res = await authFetch('/api/ab?resource=pages', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ action: 'update', pageId, page_config }),
//   });

import { supabase } from './supabase';

export async function authFetch(input, init = {}) {
  let token = null;
  try {
    const { data } = await supabase.auth.getSession();
    token = data?.session?.access_token || null;
  } catch {
    // No session — fall through; the server will reject with 401.
  }

  const headers = new Headers(init.headers || {});
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return fetch(input, { ...init, headers });
}

export default authFetch;
